import React, { useState,useRef } from 'react'
import { DatePicker, Button, Table, Select, Input,Space,Typography,Form } from 'antd';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import '../consumocliente.css'
import Highlighter from 'react-highlight-words';
import { SearchOutlined,ArrowLeftOutlined } from '@ant-design/icons';
import moment from 'moment';
import * as XLSX from 'xlsx';
const { Title } = Typography;

function ConsumoInadequado() {

    const history = useHistory();
    const [selectedKeys,setSelectedKeys]=useState();
    const [datas,setDatas]=useState();
    const [error,setError]=useState(null);
    const [record,setRecords]=useState(null);
    const [data,setData]=useState(null);
    const searchInput = useRef(null);
    const [searchedColumn, setSearchedColumn] = useState('');
    const [searchText, setSearchText] = useState('');

    const handleDateChange = (dates) => {
        if (dates && dates.length === 2) {
          
          setSelectedKeys(dates);
          setDatas(dates);
        } else {
          setSelectedKeys([]);
        }
      };
      const handleExport = () => {
        const selectedKeys = ['idcliente','nome','valor_cosumido_total','total_consumed'];
        const filteredData = data.map((item) => {
          const filteredItem = {};
          selectedKeys.forEach((key) => {
            if (item.hasOwnProperty(key)) {
              filteredItem[key] = item[key];
            }
          });
          return filteredItem;
        });
    
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
    
        // Add the column names as the first row in the worksheet
        const columnNames = columns.map((column) => column.title);
        XLSX.utils.sheet_add_aoa(worksheet, [columnNames], { origin: 'A1' });
    
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, 'compras_inadequadas_cliente.xlsx');
      };
      const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
      };
  
      const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
      const handleConfirm = () => {
        if (selectedKeys.length === 2) {
            const [startDate, endDate] = datas;
        const startDateObj = new Date(startDate);
        const endDateObj = new Date(endDate);
        startDateObj.setHours(0, 0, 0, 0);
        endDateObj.setHours(0, 0, 0, 0);
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/consumo_Inaquado/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{datainicio:startDateObj,fimdata:endDateObj}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
                console.log(d.data);
                setData(d.data);
                setRecords(d.data);
         }
       
           ).catch(e=>{
            setError(e.message );
        })



        }
      };
      const getColumnSearchProps = (dataIndex) => {
        return {
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
              <Input
                ref={searchInput}
                placeholder={`Search ${dataIndex}`}
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                style={{ marginBottom: 8, display: 'block' }}
              />
              <Space>
                <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                >
                  Search
                </Button>
                <Button onClick={() => clearFilters && handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  Reset
                </Button>
                <Button
                  type="link"
                  size="small"
                  onClick={() => {
                    confirm({ closeDropdown: false });
                    setSearchText(selectedKeys[0]);
                    setSearchedColumn(dataIndex);
                  }}
                >
                  Filter
                </Button>
                <Button type="link" size="small" onClick={confirm}>
                  Close
                </Button>
              </Space>
            </div>
          ),
          filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />,
          onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => searchInput.current.select(), 100);
            }
          },
          render: (text) =>
            searchedColumn === dataIndex ? (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={text ? text.toString() : ''}
              />
            ) : (
              text
            ),
        };
      };
    const columns = [
        {
          
            title: 'idcliente',
          dataIndex: 'idcliente',
          key: 'idcliente',
          render: (text) => <a>{text}</a>,

        },
        {
          title: 'Nome',
          dataIndex: 'nome',
          key: 'nome',
          render: (text) => <a>{text}</a>,
        },
       


        {
          title: 'Valor Pago Total',
          key: 'valor_cosumido_total',
          dataIndex: 'valor_cosumido_total',
          render: (value) => parseFloat(value).toFixed(2),
        },
        {
            title: 'total consumido em m3',
            key: 'total_consumed',
            dataIndex: 'total_consumed',
            render: (value) => parseFloat(value).toFixed(2),
          },
        
  
      ];

      const onChange = (pagination, filters, sorter, extra) => {
        setData(extra.currentDataSource);
      };
    
  
  return (
    <div>  
             <Title onClick={() => { history.goBack(); }} className='volta_' level={3}> <ArrowLeftOutlined/> Cliente com consumo Inadequado</Title>
   
        <Space>
    <DatePicker.RangePicker
      value={selectedKeys}
      onChange={handleDateChange}
      onOk={handleConfirm}
      
    />
    <Button type="primary"   onClick={handleConfirm}>
      Pesquisar
    </Button>
    
  </Space>
<div style={{marginTop:'2%'}}>

</div>
  {record && <>
        <Table
            className="tabela-recat-native"
            columns={columns}
            onChange={onChange}
            dataSource={record}
            pagination={{
              pageSize: 10,
            }}
          />        

    </>}

            {record && <Space>
  <Button onClick={handleExport}>Export to Excel</Button>

  </Space>}
  



</div>
  )

}

export default ConsumoInadequado